import { FormProvider, useForm } from 'react-hook-form'
import { PageHeader } from './components/page-header'
import { StepsContent } from './components/steps-content'
import { EMPTY_UPLOAD_FORM } from './constants'
import { TranslationUploadForm } from './types'

export const UploadTranslationStepper = () => {
  const methods = useForm<TranslationUploadForm>({
    defaultValues: EMPTY_UPLOAD_FORM,
    reValidateMode: 'onChange',
    mode: 'onChange',
  })

  return (
    <FormProvider {...methods}>
      <PageHeader />
      <StepsContent />
    </FormProvider>
  )
}
